import PropTypes from "prop-types";
import classNames from "classnames";

const IconNewSearch = ({ className, height = "16px", width = "16px" }) => {
    const classes = classNames("searchIcon", className);

    return (
        <svg
            className={classes}
            width={width}
            height={height}
            viewBox="0 0 16 16"
            focusable="false"
            data-testid="searchIcon"
        >
            <path
                id="icon"
                d="M14.2744 16L8.85699 10.4C8.42704 10.7556 7.9326 11.037 7.37366 11.2444C6.81472 11.4519 6.21996 11.5556 5.58936 11.5556C4.02721 11.5556 2.70511 10.9963 1.62307 9.87778C0.541022 8.75926 0 7.39259 0 5.77778C0 4.16296 0.541022 2.7963 1.62307 1.67778C2.70511 0.559259 4.02721 0 5.58936 0C7.15152 0 8.47362 0.559259 9.55566 1.67778C10.6377 2.7963 11.1787 4.16296 11.1787 5.77778C11.1787 6.42963 11.0784 7.04444 10.8778 7.62222C10.6771 8.2 10.4048 8.71111 10.0609 9.15556L15.4782 14.7556L14.2744 16ZM5.58936 9.77778C6.66424 9.77778 7.57789 9.38889 8.3303 8.61111C9.08272 7.83333 9.45892 6.88889 9.45892 5.77778C9.45892 4.66667 9.08272 3.72222 8.3303 2.94444C7.57789 2.16667 6.66424 1.77778 5.58936 1.77778C4.51449 1.77778 3.60084 2.16667 2.84843 2.94444C2.09601 3.72222 1.7198 4.66667 1.7198 5.77778C1.7198 6.88889 2.09601 7.83333 2.84843 8.61111C3.60084 9.38889 4.51449 9.77778 5.58936 9.77778Z"
            />
        </svg>
    );
};

IconNewSearch.propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
};

export default IconNewSearch;
